<template>
  <div class="steps-container">
    <div
      v-for="(step, index) in steps"
      :key="step.id"
      :class="['step', { active: index + 1 <= currentStep }]"
    >
      <div class="border-step">
        <span v-if="index + 1 <= currentStep" class="step-count">
          <img src="~@/assets/images/vector.png" />
        </span>
        <span
          v-else
          :class="['step-count', currentStep + 1 === step.id ? 'current-step' : '']"
          >{{ step.id }}</span
        >
      </div>
      <div
        :class="['step-label', currentStep + 1 === step.id ? 'current-step-text' : '']"
      >
        {{ step.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    currentStep: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
